module.exports = __webpack_public_path__ + "assets/pdf/E17-en-extreme-cold.18c920e4.pdf";